// export default withTranslation()(Dashboard);
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable array-callback-return */
import * as React from "react";
import { withTranslation } from "react-i18next";
import i18n from "../i18n";
import { DataService } from "../services/DataService";
import ExpectedReportsBarChart from "../components/DashboardComps/ExpectedReportsBarChart";
import { Button, Spinner, Stack } from "react-bootstrap";
import {
  ICategoryForPieChart,
  IDashboardCategorys,
  IDashboardExpectedReports,
  IData_fordashboardCard,
  IInvoiceDataForPieChart,
} from "../services/API/DashBoard";
import PieChartCategorys from "../components/DashboardComps/PieChartCategorys";
import Card from "../components/DashboardComps/Card";
import {
  SvgForKickbackReports,
  SvgForNullReports,
  SvgForStatisticReports,
} from "../components/DashboardComps/SvgIcons";
import CategoryModal from "../components/DashboardComps/CategoryModal";
import { ProjectReportSnapshotBackfillModal } from "../components/DashboardComps/ProjectReportSnapshotBackfillModal";
import ViewCard from "../components/DashboardComps/ViewCard";
import { RoundTo } from "../lib/utils";
import CalendarYearPie from "../components/DashboardComps/CalendarYearPie";
import AcademicyearModal from "../components/DashboardComps/AcademicyearModal";
import AuthService from "../services/AuthService";

interface IDashboardProps {}
interface IDashboardState {
  loading: boolean;
  loadingCards: boolean;
  expectedReports: IDashboardExpectedReports[];
  categorys: IDashboardCategorys;
  period: string;
  statistikRapporterCard: IData_fordashboardCard[];
  nollRapporterCard: IData_fordashboardCard[];
  kickbackRapporterCard: IData_fordashboardCard[];
  periodIndex: number;
  yearFilter: string[];
  showCategoryModal: boolean;
  dataForCategoryModal: any[];
  summedDataForPie: IInvoiceDataForPieChart[];
  dataForPie: ICategoryForPieChart[];
  selectedCategory: string;
  filterdByYear: any[];
  aggregatedYear: AggregatedYear[];
  activePie: "month" | "year"; // <-- NY
  selectedAcademicYear: { period: string; typeOfEvent: string };
  showAcademicyearModal: boolean;
  showProjectBackfillModal: boolean;
}

type PeriodRow = {
  period: string; // "YYYY-MM"
  reportsExpected: number;
  reportsReceived: number;
  invoiceReports: number;
  nullReports: number;
  csrdReports: number;
};

type AggregatedYear = {
  academicYearKey: string;
  label: string;
  reportsExpected: number;
  reportsReceived: number;
};

function getCurrentPeriod(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

function getPreviousPeriod(): string {
  const now = new Date();
  const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const year = prev.getFullYear();
  const month = String(prev.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

function isCurrentAcademicYear(period: string, currentPeriod: string): boolean {
  return (
    getAcademicYearKey(period).label === getAcademicYearKey(currentPeriod).label
  );
}
function getAcademicYearKey(period: string): { key: string; label: string } {
  const m = period.trim().match(/^(\d{4})-(\d{2})$/);
  if (!m) throw new Error(`Ogiltig period: ${period}`);

  const year = Number(m[1]);
  const month = Number(m[2]);

  const startMonth = 9;
  const startYear = month >= startMonth ? year : year - 1;
  const endYear = startYear + 1;

  return {
    key: `${startYear}-09_${endYear}-08`,
    label: `${startYear}/${endYear}`,
  };
}

function aggregateByAcademicYear(
  data: PeriodRow[],
  startMonth = 9,
): AggregatedYear[] {
  const map = new Map<string, AggregatedYear>();

  for (const row of data) {
    const { key, label } = getAcademicYearKey(row.period);

    if (!map.has(key)) {
      map.set(key, {
        academicYearKey: key,
        label,
        reportsExpected: 0,
        reportsReceived: 0,
      });
    }

    const agg = map.get(key)!;
    agg.reportsExpected += row.reportsExpected;
    agg.reportsReceived += row.reportsReceived;
  }

  const result = Array.from(map.values()).sort((a, b) => {
    const aStartYear = parseInt(a.label.split("/")[0], 10);
    const bStartYear = parseInt(b.label.split("/")[0], 10);
    return aStartYear - bStartYear;
  });

  return result;
}

class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
  constructor(props: IDashboardProps) {
    super(props);
    this.state = {
      expectedReports: [],
      categorys: {} as IDashboardCategorys,
      period: "",
      statistikRapporterCard: [] as IData_fordashboardCard[],
      nollRapporterCard: [] as IData_fordashboardCard[],
      kickbackRapporterCard: [] as IData_fordashboardCard[],
      loading: true,
      periodIndex: -1,
      yearFilter: [""],
      showCategoryModal: false,
      dataForCategoryModal: [],
      loadingCards: true,
      dataForPie: [] as ICategoryForPieChart[],
      summedDataForPie: [] as IInvoiceDataForPieChart[],
      selectedCategory: "",
      filterdByYear: [],
      aggregatedYear: [],
      activePie: "month", // <-- default: månads-pie (kopplad till bar-chart)
      selectedAcademicYear: { period: "", typeOfEvent: "" },
      showAcademicyearModal: false,
      showProjectBackfillModal: false,
    };
  }

  async componentDidMount(): Promise<void> {
    const [categorys, summedDataForPie, expectedReports] = await Promise.all([
      DataService.Dashboard.GetCategorys(),
      DataService.Dashboard.GetData_IInvoiceDataForPieChart(),
      DataService.Dashboard.GetExpectedReports(),
    ]);

    const currentPeriod = getCurrentPeriod();
    const previousPeriod = getPreviousPeriod();
    const filteredExpectedReports = expectedReports.filter((x) => {
      const rowPeriod = x.period;
      const sameAcademicYear = isCurrentAcademicYear(rowPeriod, currentPeriod);

      if (!sameAcademicYear) {
        return true;
      }

      return rowPeriod <= previousPeriod;
    });

    await this.InitCards();
    await this.InitBarChart(expectedReports);
    const res = aggregateByAcademicYear(
      /*expectedReports as unknown as PeriodRow[]*/ filteredExpectedReports,
    );
    const date = new Date();
    const backUpYeah = new Date(date.getFullYear(), date.getMonth() - 1);
    const formatted = backUpYeah.toLocaleDateString("sv-SE").split("-");
    const period = `${formatted[0]}-${formatted[1]}`;

    this.setState(
      {
        categorys,
        period,
        summedDataForPie,
        expectedReports,
        aggregatedYear: res,
      },
      () => this.InitBarChart(this.state.expectedReports),
    );
  }

  InitBarChart = (expectedReports: IDashboardExpectedReports[]) => {
    const yearFilter = this.CreateYearFilter(expectedReports);
    this.FilterByYear(yearFilter.length);
    this.setState({
      yearFilter,
      periodIndex: yearFilter.length,
    });
  };

  InitCards = async () => {
    const cardData = await DataService.Dashboard.GetData_fordashboardCard();
    this.setState({
      loadingCards: false,
      statistikRapporterCard: cardData[0],
      nollRapporterCard: cardData[1],
      kickbackRapporterCard: cardData[2],
    });
  };

  CreateYearFilter = (
    expectedReports: IDashboardExpectedReports[],
  ): string[] => {
    const periods: Set<string> = new Set();
    expectedReports.map((x) =>
      periods.add(new Date(x.period).getFullYear().toString()),
    );
    const parsedPeriods: string[] = [];
    periods.forEach((x) => {
      parsedPeriods.push(x);
    });
    return parsedPeriods;
  };

  OnClickForward = () =>
    this.state.periodIndex + 1 > this.state.yearFilter.length
      ? ""
      : this.setState(
          (prevState) => ({
            periodIndex: prevState.periodIndex + 1,
          }),
          () => this.FilterByYear(this.state.periodIndex),
        );

  OnClickBackward = () =>
    this.state.periodIndex - 1 <= 0
      ? ""
      : this.setState(
          (prevState) => ({
            periodIndex: prevState.periodIndex - 1,
          }),
          () => this.FilterByYear(this.state.periodIndex),
        );

  OnClickHandlerForReportsExpectedBarChart = async (barPeriod: string) => {
    const dataForPie = await DataService.Dashboard.GetData_ICategoryForPieChart(
      `${barPeriod}-01`,
    );
    this.setState({ period: barPeriod, dataForPie });
  };
  OnClickHandlerForSelctedSliceAcademicYear = async (academicYear: any) => {
    const { name, period } = academicYear;
    this.setState({
      selectedAcademicYear: { period, typeOfEvent: name },
      showAcademicyearModal: true,
    });
  };
  OnClickHandlerForSelectedSlicePieChart = async (category: any) => {
    const categorys: { [key: string]: number } = {
      "El och Fiber": 100,
      Sinfra: 200,
      "Tjänster och Konsulter": 300,
      "Vatten och Avlopp": 400,
      "Värme och kyla": 500,
      Övrigt: 900,
      Ekonomi: 910,
      "Avfall och Återvinning": 600,
    };
    const res: IInvoiceDataForPieChart[] = [];
    for (let index = 0; index < this.state.summedDataForPie.length; index++) {
      if (
        this.state.summedDataForPie[index].categoryId ===
          categorys[category.name] &&
        this.state.summedDataForPie[index].period.includes(this.state.period)
      ) {
        res.push(this.state.summedDataForPie[index]);
      }
    }
    this.setState({
      showCategoryModal: true,
      dataForCategoryModal: res,
      selectedCategory: category.name,
    });
  };

  OnCloseHandlerForCategoryModal = () => {
    this.setState({ showCategoryModal: false });
  };
  OnCloseHandlerForAcademicyearModal = () => {
    this.setState({ showAcademicyearModal: false });
  };
  OnOpenHandlerForProjectBackfillModal = () => {
    this.setState({ showProjectBackfillModal: true });
  };
  OnCloseHandlerForProjectBackfillModal = () => {
    this.setState({ showProjectBackfillModal: false });
  };
  FilterByYear(index: number) {
    const result: any[] = [];
    for (let i = 0; i < this.state.expectedReports.length; i++) {
      const item = this.state.expectedReports[i];
      const invoiceReports = item.invoiceReports;
      const nullReports = item.nullReports;
      const totalExpected = item.reportsExpected;
      const csrdReports = item.csrdReports;

      if (
        item.period.includes(this.state.yearFilter[this.state.periodIndex - 1])
      ) {
        const procentInvoiceReports = RoundTo(
          (invoiceReports / totalExpected) * 100,
          1,
        );
        const procentNullReports = RoundTo(
          (nullReports / totalExpected) * 100,
          1,
        );
        const procentCsrdReports = RoundTo(
          (csrdReports / totalExpected) * 100,
          1,
        );
        result.push({
          period: item.period,
          reportsExpected: 100,
          invoiceReports: procentInvoiceReports,
          nullReports: procentNullReports,
          csrdReports: procentCsrdReports,
          fullyReported:
            csrdReports + invoiceReports + nullReports >= totalExpected ? 1 : 0,
          toolTipData: item,
        });
      }
    }

    this.setState({ filterdByYear: result, loading: false });
    return result;
  }

  render() {
    const currentEmail = String(
      AuthService.getUser()?.email ?? "",
    ).toLowerCase();
    const showBackfillButton = currentEmail === "test@mail.se";

    const categorys: { [key: string]: string } = {
      "100": "El och Fiber",
      "200": "Sinfra",
      "300": "Tjänster och Konsulter",
      "400": "Vatten och Avlopp",
      "500": "Värme och kyla",
      "600": "Avfall och Återvinning",
      "900": "Övrigt",
      "910": "Ekonomi",
    };

    const test: { [key: string]: number } =
      this.state.period.length > 0
        ? this.state.summedDataForPie.reduce((res: any, item) => {
            const cat = categorys[`${item.categoryId}`];
            const sumvalue = Math.round(item.priceExcMoms);
            if (
              !res[cat] &&
              sumvalue > 0 &&
              item.period.includes(this.state.period)
            ) {
              res[cat] = sumvalue;
            } else if (
              res[cat] &&
              sumvalue > 0 &&
              item.period.includes(this.state.period)
            ) {
              res[cat] += sumvalue;
            }
            return res;
          }, {})
        : {};

    const compStyles = getComputedStyle(document.documentElement);

    return (
      <div>
        {this.state.loadingCards ? (
          <Spinner />
        ) : (
          <Stack
            className="dashboardCardscontainer"
            gap={3}
            style={{ marginBottom: "10px" }}
            direction="horizontal"
          >
            <Card
              backgroundColor={compStyles.getPropertyValue(
                "--statistic-background",
              )}
              color={compStyles.getPropertyValue("--statistic-color")}
              svg={SvgForStatisticReports()}
              cardTitle={i18n.t("dashboard.invoiceReports")}
              statProcent={this.state.statistikRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.statistikRapporterCard[0].week}
              dataPointsTrendline={this.state.statistikRapporterCard}
            />

            <Card
              backgroundColor={compStyles.getPropertyValue("--zero-background")}
              color={compStyles.getPropertyValue("--zero-color")}
              svg={SvgForNullReports()}
              cardTitle={i18n.t("dashboard.nullReports")}
              statProcent={this.state.nollRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.nollRapporterCard[0].week}
              dataPointsTrendline={this.state.nollRapporterCard}
            />

            <Card
              backgroundColor={compStyles.getPropertyValue(
                "--kickback-background",
              )}
              color={compStyles.getPropertyValue("--kickback-color")}
              svg={SvgForKickbackReports()}
              cardTitle={i18n.t("dashboard.kickbackReport")}
              statProcent={this.state.kickbackRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.kickbackRapporterCard[0].week}
              dataPointsTrendline={this.state.kickbackRapporterCard}
            />
          </Stack>
        )}

        {this.state.loading ? (
          <div style={{ float: "right", marginLeft: "10px" }}>
            <Spinner />
          </div>
        ) : (
          <div className="test">
            <div className="dashboardChartsscontainer">
              <ExpectedReportsBarChart
                data={this.state.filterdByYear}
                loading={this.state.loading}
                onClick={this.OnClickHandlerForReportsExpectedBarChart}
                onClickForward={this.OnClickForward}
                onClickBackward={this.OnClickBackward}
                yearFilter={this.state.yearFilter ?? []}
                periodIndex={this.state.periodIndex}
              />
            </div>

            <div className="dashboardPieContainer">
              {/* Header med dropdown för att välja pie-typ */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "4px",
                }}
              >
                <select
                  value={this.state.activePie}
                  onChange={(e) =>
                    this.setState({
                      activePie: e.target.value as "month" | "year",
                    })
                  }
                  style={{
                    fontSize: "0.8rem",
                    padding: "2px 6px",
                    borderRadius: 4,
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#fffaf5",
                  }}
                >
                  <option value="month">
                    {i18n.t("dashboard.pie.monthly") ||
                      "Inrapporterat per kategori (månad)"}
                  </option>
                  <option value="year">
                    {i18n.t("dashboard.pie.academicYear") ||
                      "Rapporteringsöversikt (år)"}
                  </option>
                </select>
              </div>

              {/* Själva pie-yta – togglar mellan två olika komponenter */}
              {this.state.activePie === "month" ? (
                <PieChartCategorys
                  category={this.state.categorys}
                  data={test}
                  period={this.state.period}
                  onSelectedSlice={this.OnClickHandlerForSelectedSlicePieChart}
                />
              ) : (
                <CalendarYearPie
                  data={this.state.aggregatedYear}
                  onSelectedSlice={
                    this.OnClickHandlerForSelctedSliceAcademicYear
                  }
                />
              )}

              <Stack>
                <div style={{ alignSelf: "center", paddingTop: "5px" }}>
                  <ViewCard />
                  {showBackfillButton && (
                    <div style={{ marginTop: 8 }}>
                      <Button
                        className="button button-primary"
                        onClick={this.OnOpenHandlerForProjectBackfillModal}
                      >
                        Project backfill
                      </Button>
                    </div>
                  )}
                </div>
              </Stack>
            </div>
          </div>
        )}

        {this.state.showCategoryModal && (
          <CategoryModal
            onDissmissHandler={this.OnCloseHandlerForCategoryModal}
            data={this.state.dataForCategoryModal}
            period={this.state.period}
            selectedCategory={this.state.selectedCategory}
            footerSum={test[`${this.state.selectedCategory}`]}
          />
        )}
        {this.state.showAcademicyearModal && (
          <AcademicyearModal
            onDissmissHandler={this.OnCloseHandlerForAcademicyearModal}
            selectedAcademicYear={this.state.selectedAcademicYear}
          />
        )}
        {this.state.showProjectBackfillModal && (
          <ProjectReportSnapshotBackfillModal
            onDismiss={this.OnCloseHandlerForProjectBackfillModal}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(Dashboard);
